import {Component, OnInit} from '@angular/core';
import {
    GridColumn,
    MxCustomizer,
    MxGridCustomizerEvent,
    MxGridButtonsConfig,
    MxGridService,
    DefaultGridButtons,
} from 'mx-core';
import {PrlTranslateService} from '../../../../../shared/services/prl-translate.service';
import {Router} from '@angular/router';

@Component({
    selector: 'prl-contacts',
    standalone: false,
    templateUrl: './prl-contacts.component.html',
    styleUrl: './prl-contacts.component.scss',
})
export class PrlContactsComponent implements OnInit, MxCustomizer<MxGridCustomizerEvent> {
    private buttonsConfig: MxGridButtonsConfig;
    private gridColumns: GridColumn[] = [];
    private gridService: MxGridService;

    constructor(private readonly router: Router, protected readonly translateService: PrlTranslateService) {
    }

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({
                field: 'firstName',
                label: () => this.translateService.getTranslatedLabel('label.modify.account.contacts.name'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'email',
                label: () => this.translateService.getTranslatedLabel('label.email'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'contactTypeName',
                label: () => this.translateService.getTranslatedLabel('label.modify.account.contact.type'),
                sortable: true,
                hidden: false
            })
        ];

        this.buttonsConfig = new MxGridButtonsConfig([
                [DefaultGridButtons.add, {
                    label: () => this.translateService.getTranslatedLabel('label.modify.account.create.contact'),
                    icon: 'add',
                    tooltip: () => this.translateService.getTranslatedLabel('label.modify.account.create.contact'),
                    className: 'mxs-button--secondary',
                    clickHandler: () => this.router.navigate(['/account/contacts/new'])
                }],
                [DefaultGridButtons.edit, {
                    tooltip: () => this.translateService.getTranslatedLabel('label.modify.account.edit.contact'),
                    className: 'mxs-button--round mxs-button--secondary'
                }],
                [DefaultGridButtons.remove, {
                    hidden: true
                }],
                [DefaultGridButtons.view, {
                    hidden: true
                }],
                [DefaultGridButtons.reload, {
                    hidden: true
                }]
            ]);

    }

    onCustomize(event: MxGridCustomizerEvent): void {
        event
            .customizeRestUrl('/account/contacts')
            .customizeItemDetailsLink('/account/contacts')
            .customizeLoadRowsOnStart(true)
            .customizeColumns(this.gridColumns)
            .customizeActions(this.buttonsConfig)
            .customizeProps({
                selectionMode: 'single',
                readonly: true,
                showButtons: true,
                showColumns: false
            })
            .onSetUp(service => {
                this.gridService = service;
            });
    }


}
